/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
import clsx from 'classnames';
import { TableSize } from '@components/Table';
import './DraggableTable.scss';
function DraggableTable({ data, columns, variant = 'detail', size = TableSize.Auto, onPositionChange, getItemId, expandableRowRenderer, onRowClick, expandedRows, hover = false }) {
    const [draggedItem, setDraggedItem] = useState(null);
    const [draggedOverIndex, setDraggedOverIndex] = useState(null);
    const handleDragStart = (event, item) => {
        setDraggedItem(item);
        event.dataTransfer.effectAllowed = 'move';
    };
    const handleDragOver = (event, index) => {
        event.preventDefault();
        event.dataTransfer.dropEffect = 'move';
        setDraggedOverIndex(index);
    };
    const handleDragLeave = () => {
        setDraggedOverIndex(null);
    };
    const handleDrop = (event, dropIndex) => {
        event.preventDefault();
        setDraggedOverIndex(null);
        if (!draggedItem || !onPositionChange) {
            return;
        }
        const draggedIndex = data.findIndex((item) => getItemId(item) === getItemId(draggedItem));
        if (draggedIndex === dropIndex || draggedIndex === -1) {
            setDraggedItem(null);
            return;
        }
        // Create new array with reordered items
        const newData = [...data];
        const [removed] = newData.splice(draggedIndex, 1);
        newData.splice(dropIndex, 0, removed);
        setDraggedItem(null);
        onPositionChange(newData);
    };
    const handleDragEnd = () => {
        setDraggedItem(null);
        setDraggedOverIndex(null);
    };
    // Create drag handle column
    const dragHandleColumn = {
        label: '',
        dataKey: 'drag-handle',
        width: 40,
        renderer: () => (React.createElement("div", { className: "drag-handle", "aria-label": "Drag to reorder" },
            React.createElement("i", { className: "fa fa-grip-dots-vertical" })))
    };
    // Combine drag handle column with user columns
    const allColumns = [dragHandleColumn, ...columns];
    return (React.createElement("div", { 
        /* eslint-disable @typescript-eslint/naming-convention */
        className: clsx('draggable-table', {
            'qmb-table--01': variant === 'listing',
            'qmb-table--02': variant === 'detail'
        }), 
        /* eslint-enable @typescript-eslint/naming-convention */
        style: size === TableSize.Full ? { width: '100%' } : {} },
        React.createElement("table", { className: "main-table", style: size === TableSize.Full ? { width: '100%' } : {} },
            React.createElement("thead", null,
                React.createElement("tr", null, allColumns.map((column) => (React.createElement("th", { key: column.dataKey, style: column.width ? { width: column.width } : undefined }, column.label))))),
            React.createElement("tbody", { className: "qmb-drag-body" }, data.map((row, rowIdx) => {
                const isDragging = draggedItem && getItemId(draggedItem) === getItemId(row);
                const isDraggedOver = draggedOverIndex === rowIdx;
                return (React.createElement(React.Fragment, { key: `draggable-row-${getItemId(row)}` },
                    React.createElement("tr", { draggable: true, onDragStart: (e) => handleDragStart(e, row), onDragOver: (e) => handleDragOver(e, rowIdx), onDragLeave: () => handleDragLeave(), onDrop: (e) => handleDrop(e, rowIdx), onDragEnd: () => handleDragEnd(), onClick: (event) => {
                            if (onRowClick) {
                                onRowClick({ item: row }, event);
                            }
                        }, 
                        /* eslint-disable @typescript-eslint/naming-convention */
                        className: clsx('qmb-draggable draggable-row', {
                            'is-dragging': isDragging,
                            'drag-over': isDraggedOver,
                            'expandable-row': expandableRowRenderer,
                            hoverable: hover
                        }) }, allColumns.map((column, colIdx) => (React.createElement("td", { key: `table-row-${column.dataKey}-${rowIdx}`, 
                        /* eslint-disable @typescript-eslint/naming-convention */
                        className: clsx({
                            cellAlignRight: column.align === 'right',
                            'drag-handle-cell': colIdx === 0
                        }) }, column.renderer
                        ? React.createElement(column.renderer, {
                            item: row,
                            dataKey: column.dataKey,
                            index: rowIdx,
                            key: `renderer-${column.dataKey}-${rowIdx}`
                        })
                        : String(row[column.dataKey] || ''))))),
                    expandedRows && expandedRows[getItemId(row)] && expandableRowRenderer && (React.createElement(React.Fragment, null, expandableRowRenderer({ item: row })))));
            })))));
}
export default DraggableTable;
